import React from "react";
import Reveal from "../common/Reveal";
import workExperience from "../data/workExperience";

export default function Experience() {
  return (
    <section id="work" className="section">
      <div className="section-inner">
        <Reveal className="section-label-row">
          <span className="section-label mono">03 / EXPERIENCE</span>
          <span className="section-line" />
        </Reveal>
        <Reveal as="h2" className="section-headline">
          Three years, four teams, one clear line of growth.
        </Reveal>

        {workExperience.map((entry) => (
          <Reveal as="div" className="exp-row" key={entry.company}>
            <div className="exp-left">
              <span className="exp-year mono">{entry.year}</span>
              {entry.current && (
                <span className="exp-current live-indicator mono">
                  <span className="pulse-dot" />
                  CURRENT
                </span>
              )}
            </div>
            <div className="exp-right">
              <h3 className={`exp-company ${entry.subtitle ? "" : "no-subtitle"}`}>
                {entry.company}
              </h3>
              {entry.subtitle && (
                <p className="exp-subtitle mono">{entry.subtitle}</p>
              )}
              <div className="exp-roles">
                {entry.roles.map((role) => (
                  <div className="exp-role-row" key={role.title}>
                    {role.index && (
                      <span className="exp-role-index mono">{role.index}</span>
                    )}
                    <span
                      className={`exp-role-title ${role.emphasis ? "emphasis" : ""}`}
                    >
                      {role.title}
                    </span>
                    <span className="exp-role-date mono">{role.date}</span>
                  </div>
                ))}
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
